import type { MisconceptionDefinition } from '../types'

export const bijvoeglijkNieuwMisconceptions: MisconceptionDefinition[] = [
  // --- Bijvoeglijk gebruikt VD (SWW-BN-VD-KORT, SWW-BN-VD-DUBBEL) ---
  {
    id: 'sww.bn-short-vowel-not-doubled',
    label: 'Korte klinker-medeklinker niet verdubbeld bij verbuiging',
    module: 'SpellingWW',
    description:
      'Bij verbuiging van een bijvoeglijk gebruikt VD met korte klinker moet de medeklinker verdubbeld worden ("gestopt" → "gestopte"); leerling laat de verdubbeling weg.',
    typicalFamilies: ['SWW-BN-VD-DUBBEL'],
  },
  {
    id: 'sww.bn-uitgang-en-instead-of-e',
    label: 'Uitgang -en gebruikt waar -e hoort bij verbuiging',
    module: 'SpellingWW',
    description:
      'Leerling gebruikt -en als verbuigings-uitgang van het bijvoeglijk gebruikte VD ("gestoppen man") in plaats van de juiste -e ("gestopte man").',
    typicalFamilies: ['SWW-BN-VD-DUBBEL', 'SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-infinitief-gebruikt',
    label: 'Infinitief gebruikt als bijvoeglijk naamwoord',
    module: 'SpellingWW',
    description:
      'Leerling gebruikt de infinitief (hele werkwoord) als bijvoeglijk naamwoord ("de breken vaas") in plaats van de juiste VD-verbuigingsvorm ("de gebroken vaas").',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-lange-klank-verdubbeld',
    label: 'Lange klinker onterecht verdubbeld bij verbuiging',
    module: 'SpellingWW',
    description:
      'Leerling verdubbelt de klinker bij verbuiging van een bijvoeglijk gebruikt VD met lange klinker ("geslaapen" i.p.v. "geslapen"), terwijl een open lettergreep enkele klinker vereist.',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-ene-toegevoegd',
    label: 'Uitgang -ene toegevoegd i.p.v. -e',
    module: 'SpellingWW',
    description:
      'Leerling voegt -ene toe als verbuigings-uitgang ("gebrokene vaas") in plaats van de juiste -e ("gebroken vaas").',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-en-toegevoegd',
    label: 'Uitgang -en toegevoegd waar geen verbuiging hoort',
    module: 'SpellingWW',
    description:
      'Leerling voegt -en toe aan een bijvoeglijk gebruikt VD waar geen of een andere verbuiging hoort (bv. predicatief gebruik), door de meervoudsregel te overgeneraliseren.',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-kofschip-misapplied',
    label: 'Kofschip-regel verkeerd toegepast op bijvoeglijk VD',
    module: 'SpellingWW',
    description:
      'Leerling past de kofschip-regel toe op een bijvoeglijk gebruikt VD-vorm waarbij de regel niet relevant is (de VD-vorm staat al vast).',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-cluster-verdubbeld',
    label: 'Medeklinkercluster onterecht verdubbeld bij verbuiging',
    module: 'SpellingWW',
    description:
      'Leerling verdubbelt een medeklinker in een cluster bij verbuiging (bv. "gewerktte") terwijl de spellingregel dat niet vereist.',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-e-vergeten',
    label: 'Verbuigings-e vergeten bij bijvoeglijk gebruikt VD',
    module: 'SpellingWW',
    description:
      'Leerling vergeet de verbuigings-e bij een bijvoeglijk gebruikt VD vóór een de-woord (bv. "de gestopt auto" i.p.v. "de gestopte auto"). De VD heeft attributief gebruik dus een -e nodig; alleen predicatief gebruik ("de auto is gestopt") blijft zonder -e.',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-sterke-vd-als-fout',
    label: 'Correcte sterke VD-verbuiging aangezien voor fout',
    module: 'SpellingWW',
    description:
      'Leerling kiest een correct verbogen sterk VD (bv. "gelopen man") als foutief antwoord, omdat hij denkt dat de -en uitgang van het sterke VD onverbogen vorm-fout is.',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-sterk-als-zwak',
    label: 'Sterk VD verbogen volgens zwakke regel',
    module: 'SpellingWW',
    description:
      'Leerling past de zwakke VD-verbuiging (-de/-te + e) toe op een sterk VD ("de geloopte man") in plaats van de sterke VD-vorm ("de gelopen man") te gebruiken.',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  {
    id: 'sww.bn-eind-n-weggelaten',
    label: 'Eind-n weggelaten bij sterk VD in verbuiging',
    module: 'SpellingWW',
    description:
      'Leerling laat de eind-n van het sterke VD weg bij verbuiging ("de gelope man" i.p.v. "de gelopen man"), door over te generaliseren vanuit spreektaal.',
    typicalFamilies: ['SWW-BN-VD-KORT'],
  },
  // ─── Duplicate block (lines 242-321) removed mei 2026 ─────────────────
  // The entries below (sww.inversie-t-niet-weg, sww.inversie-t-vergeten,
  // sww.inversie-infinitief, sww.zijnhebben-correct-als-fout,
  // sww.gebiedende-met-t, sww.correct-form-marked-wrong,
  // sww.meervoud-als-enkelvoud-vervoegd, sww.stam-alleen-bij-meervoud,
  // sww.gebiedende-niet-herkend) were declared TWICE in this file.
  // The canonical definitions remain in the first occurrence (lines 240-321).
  // ───────────────────────────────────────────────────────────────────────
  // === Nieuw (SWW review mei 2026) ===
  {
    id: 'sww.tense-signal-ignored',
    label: 'Signaalwoord voor tijd genegeerd',
    module: 'SpellingWW',
    description:
      'Leerling negeert een expliciet tijdssignaalwoord ("gisteren", "vorige week", "morgen") en kiest een verkeerde werkwoordstijd. Verschilt van algemene tt-vt-verwarring: de fout zit niet in domeinkennis maar in signaal-blindheid — het tijdwoord is wel aanwezig maar wordt niet gebruikt als trigger.',
    typicalFamilies: ['SWW-LEEN-ENG-KOF', 'SWW-VD-HOMOFOON'],
  },
  {
    id: 'sww.dt-overgeneralize',
    label: 'Onnodige dubbele letter (dt/tt) toegevoegd',
    module: 'SpellingWW',
    description:
      'Leerling voegt een dubbele letter toe (-tt, -dd) waar de stam niet op t of d eindigt (bv. "paktte" i.p.v. "pakte", "werktten" i.p.v. "werkten"). Klassieke overgeneralisatie: kind heeft geleerd dat dubbele letters voorkomen bij stam-t/d en past dat te breed toe.',
    typicalFamilies: ['SWW-VT-DUBBEL', 'SWW-VT-ZWAK-KOF'],
  },
  {
    id: 'sww.bn-instead-of-vd',
    label: 'Bijvoeglijke vorm (+e) gebruikt waar VD nodig is',
    module: 'SpellingWW',
    description:
      'Leerling kiest de bijvoeglijke verbuigingsvorm (VD + -e, bv. "gedouchte") op een plek waar het kale voltooid deelwoord (zonder verbuiging) hoort. Verschilt van bn-uitgang-en-instead-of-e: hier is de keuze tussen verbuigd BN-gebruik en predicatief VD-gebruik, niet tussen -e en -en.',
    typicalFamilies: ['SWW-LEEN-FRANS'],
  },
]
